import ResourceLink from 'models/resourceLink';
import AppError from 'utils/appError';
import http from './httpService';

export async function apiRefreshLinkContent(link: ResourceLink, accessToken: string): Promise<void> {
  try {
    await http.post(`/search/links/${link.linkId}/content/refresh`, undefined, http.getRequestConfig(accessToken));
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}
